// Helper to access global properties if needed, though in constants files it's harder.
// We will export a function that takes the context (this) to generate headers with translations.

export const getRuHeaders = (context) => [
  {
    value: "period",
    text: context.$nova.labelsName('approvals_page','month_label','Period'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "datatypes",
    text: "",
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "control_thresholds_amount",
    text: context.$nova.labelsName('approvals_page','commentary_local_control_amount_shortform_label','LC Amt'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "control_thresholds_percent",
    text: context.$nova.labelsName('approvals_page','commentary_local_control_percentage_shortform_label','LC %'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "management_thresholds_amount",
    text: context.$nova.labelsName('approvals_page','commentary_local_management_amount_shortform_label','LM Amt'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "management_thresholds_percent",
    text: context.$nova.labelsName('approvals_page','commentary_local_management_precentage_shortform_label','LM %'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "control_thresholds_amount_regional",
    text: context.$nova.labelsName('approvals_page','commentary_regional_control_amount_shortform_label','RC Amt'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "control_thresholds_percent_regional",
    text: context.$nova.labelsName('approvals_page','commentary_regional_control_percentage_shortform_label','RC %'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "management_thresholds_amount_regional",
    text: context.$nova.labelsName('approvals_page','commentary_regional_management_amount_shortform_label','RM Amt'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "management_thresholds_percent_regional",
    text: context.$nova.labelsName('approvals_page','commentary_regional_management_percentage_shortform_label','RM %') ,
    alignment: "text-left",
    sortable: false,
  },
];

export const getGlHeaders = (context) => [
  {
    value: "period",
    text: context.$nova.labelsName('approvals_page','month_label','Period'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "gl_code_desc",
    text: context.$nova.labelsName('approvals_page','gl_code_description_label','GL Code & Description'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "datatypes",
    text: "",
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "control_thresholds_amount",
    text: context.$nova.labelsName('approvals_page','commentary_local_control_amount_shortform_label','LC Amt'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "control_thresholds_percent",
    text: context.$nova.labelsName('approvals_page','commentary_local_control_percentage_shortform_label','LC %'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "management_thresholds_amount",
    text: context.$nova.labelsName('approvals_page','commentary_local_management_amount_shortform_label','LM Amt'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "management_thresholds_percent",
    text: context.$nova.labelsName('approvals_page','commentary_local_management_precentage_shortform_label','LM %'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "control_thresholds_amount_regional",
    text: context.$nova.labelsName('approvals_page','commentary_regional_control_amount_shortform_label','RC Amt'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "control_thresholds_percent_regional",
    text: context.$nova.labelsName('approvals_page','commentary_regional_control_percentage_shortform_label','RC %'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "management_thresholds_amount_regional",
    text: context.$nova.labelsName('approvals_page','commentary_regional_management_amount_shortform_label','RM Amt'),
    alignment: "text-left",
    sortable: false,
  },
  {
    value: "management_thresholds_percent_regional",
    text: context.$nova.labelsName('approvals_page','commentary_regional_management_percentage_shortform_label','RM %') ,
    alignment: "text-left",
    sortable: false,
  },
];
